import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../base';
import { DocumentDetailLoader } from './documentDetailInterface';
import { DocumentDetailAggregate } from './documentDetailModel';

export function createDocumentDetailLoader(
    config: ReportingLoaderBaseConfig
): DocumentDetailLoader {
    const { repository } = config;
    return {
        useLoad(context, props): DocumentDetailAggregate {
            const contentQuery = repository.research.document.useLookup(
                context,
                { contentId: props.document.id },
                { suspense: true }
            );

            const blockQuery = repository.research.block.useFind(
                context,
                { content: props.document.id },
                {
                    staleTime: Infinity,
                    suspense: true,
                }
            );

            assert(contentQuery.status === 'success', 'expected suspense');
            assert(blockQuery.status === 'success', 'expected suspense');

            return {
                document: contentQuery.data,
                blocks: blockQuery.data,
            };
        },
    };
}
